import {
  Matrix4,
  DoubleSide,
} from "three";

const SparkleShader = {
  vertexShader: [
    "varying vec2 vUv;",
    "varying vec4 sparkleProjectedCentre;",
    "uniform mat4 ModelViewMatrix;",
    "uniform float scale;",
    "uniform float rotation;",
    "void main() { ",
      "vUv = uv; ",
      "vec4 finalPosition;",
      "vec2 alignedPosition = position.xy * scale;",
      "vec2 rotatedPosition;",
      "rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;",
      "rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;",
      "finalPosition = ModelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );",
      "finalPosition.xy += rotatedPosition;",
      "finalPosition = projectionMatrix * finalPosition;",
      "sparkleProjectedCentre = projectionMatrix * ModelViewMatrix * vec4(0.0,0.0,0.0,1.0 );",
      "gl_Position = finalPosition;",
    "}",
  ].join("\n"),

  fragmentShader: [
    "varying vec2 vUv;",
    "varying vec4 sparkleProjectedCentre;",
    "uniform sampler2D sparkleTexture;",
    "uniform sampler2D screenTexture;",
    "uniform sampler2D noiseTexture;",
    "uniform float intensity;",

    "vec4 recoverGamma( in vec4 value ) {",
      "return vec4( pow( value.rgb, vec3( 0.45 ) ), value.a );",
    "}",

    "vec3 ClosestPrimaryColor(vec3 color) {",
      "vec3 diffColor1 = vec3(1.0,0.0,0.0) - color;",
      "vec3 diffColor2 = vec3(0.0,1.0,0.0) - color;",
      "vec3 diffColor3 = vec3(0.0,0.0,1.0) - color;",
      "const float margin = 0.5; ",
      "if(dot(diffColor1, diffColor1) < margin)",
      "return vec3(1.0, margin, margin); ",
      "if(dot(diffColor2, diffColor2) < margin)",
      "return vec3(margin, 1.0, margin);",
      "if(dot(diffColor3, diffColor3) < margin)",
      "return vec3(margin, margin, 1.0);",
      "return color;",
    "}",

    "void main() {",
      "vec2 uv = (sparkleProjectedCentre.xy/sparkleProjectedCentre.w + 1.0)*0.5;",
      "vec4 screenColor = recoverGamma(texture2D( screenTexture, uv ));",
      "//screenColor.rgb = ClosestPrimaryColor(screenColor.rgb);",
      "float noise = texture2D( noiseTexture, uv ).r;",
      "screenColor.xyz *= screenColor.xyz;",
      "screenColor.xyz *= screenColor.xyz;",
      "screenColor.xyz *= screenColor.xyz;",
      "//float luminance = dot(vec3(0.3, 0.59, 0.11), screenColor.xyz);",
      "//luminance = luminance > 0.0 ? luminance : 0.0;",
      "vec4 spriteColor = vec4(1.) * texture2D( sparkleTexture, vUv ).a * screenColor * noise * intensity;",
      "gl_FragColor = spriteColor;",
    "}",

  ].join("\n"),

  uniforms: {
    "ModelViewMatrix": {
      type: "m4",
      value: new Matrix4().identity()
    },
    "sparkleTexture": {
      type: "t",
      value: null
    },
    "screenTexture": {
      type: "t",
      value: null
    },
    "noiseTexture": {
      type: "t",
      value: null
    },
    "scale": {
      type: "f",
      value: 1.0
    },
    "rotation": {
      type: "f",
      value: 0
    },
    "intensity": {
      type: "f",
      value: 1.0
    },
  },
  side: DoubleSide
};

export default SparkleShader;